import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSalesOrder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 25,
	viewBox: "0 0 23 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.726309 23.4157V14.3887H0V23.4157C0 24.15 0.597365 24.7473 1.33157 24.7473H7.72987V24.021H1.33157C0.997804 24.021 0.726309 23.7495 0.726309 23.4157Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.46289 24.0137H15.7095V24.74H8.46289V24.0137Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.72631 2.1063C0.72631 1.77254 0.997805 1.50104 1.33157 1.50104H4.84207V2.22735H1.45262V23.2903H14.4594V22.564H2.17893V2.95366H4.85321C4.93678 3.60812 5.49686 4.11576 6.17364 4.11576H7.48792V3.38945H6.17364C5.83987 3.38945 5.56838 3.11795 5.56838 2.78419V0.72631H13.5578V2.78419C13.5578 3.11795 13.2863 3.38945 12.9525 3.38945H8.21423V4.11576H12.9525C13.6293 4.11576 14.1894 3.60812 14.273 2.95366H16.9472V15.7851H17.6735V2.22735H14.2841V1.50104H17.7946C18.1284 1.50104 18.3999 1.77254 18.3999 2.1063V3.70418H19.1262V2.1063C19.1262 1.37205 18.5288 0.774731 17.7946 0.774731H14.2841V0H4.84207V0.774731H1.33157C0.597366 0.774731 0 1.37205 0 2.1063V13.658H0.72631V2.1063Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4004 4.42578H19.1267V15.5625H18.4004V4.42578Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.03125 15.3008H10.2943V16.0271H3.03125V15.3008Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.03125 18.6934H10.2943V19.4197H3.03125V18.6934Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.03125 20.1426H8.35752V20.8689H3.03125V20.1426Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.197 20.1461H18.3254C18.0984 20.1461 17.9138 19.9615 17.9138 19.7345C17.9138 19.5076 18.0984 19.3229 18.3254 19.3229H19.9717V18.5966H19.1243V17.8945H18.398V18.5966H18.3254C17.698 18.5966 17.1875 19.1071 17.1875 19.7345C17.1875 20.362 17.698 20.8724 18.3254 20.8724H19.197C19.4239 20.8724 19.6085 21.057 19.6085 21.284C19.6085 21.5109 19.4239 21.6956 19.197 21.6956H17.5507V22.4219H18.398V23.124H19.1243V22.4219H19.197C19.8244 22.4219 20.3348 21.9114 20.3348 21.284C20.3348 20.6565 19.8244 20.1461 19.197 20.1461Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.7642 16.2734C16.428 16.2734 14.5273 18.174 14.5273 20.5102C14.5273 22.8464 16.428 24.747 18.7642 24.747C21.1004 24.747 23.001 22.8464 23.001 20.5102C23.001 18.174 21.1004 16.2734 18.7642 16.2734ZM18.7642 24.0207C16.8284 24.0207 15.2537 22.446 15.2537 20.5102C15.2537 18.5745 16.8284 16.9997 18.7642 16.9997C20.6999 16.9997 22.2747 18.5745 22.2747 20.5102C22.2747 22.446 20.6999 24.0207 18.7642 24.0207Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.916 15.3008H16.0949V16.0271H13.916V15.3008Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 12.0187V7.65291C12 7.29289 11.6903 7 11.3096 7H6.69044C6.30974 7 6 7.29292 6 7.65291V10.1723C6 10.2917 6.10236 10.3884 6.22862 10.3884C6.35488 10.3884 6.45725 10.2917 6.45725 10.1723V7.65291C6.45725 7.5312 6.56187 7.4322 6.69044 7.4322H8.03234V8.64752C8.03234 8.78951 8.11395 8.92046 8.24533 8.98927C8.30773 9.02197 8.37677 9.03822 8.44569 9.03822C8.52187 9.03822 8.59796 9.01837 8.66481 8.97884L9 8.78081L9.33519 8.97884C9.46255 9.05407 9.62329 9.05805 9.75467 8.98924C9.88605 8.92041 9.96766 8.78945 9.96766 8.64749V7.4322H11.3096C11.4381 7.4322 11.5428 7.53123 11.5428 7.65291V12.0187C11.5428 12.1402 11.4381 12.2391 11.3096 12.2391H6.69044C6.56187 12.2391 6.45725 12.1402 6.45725 12.0187V11.1837C6.45725 11.0643 6.35488 10.9676 6.22862 10.9676C6.10236 10.9676 6 11.0643 6 11.1837V12.0187C6 12.3785 6.30974 12.6713 6.69044 12.6713H11.3096C11.6903 12.6713 12 12.3785 12 12.0187ZM9.51041 8.57272L9.21911 8.40061C9.08599 8.32195 8.91398 8.32195 8.78092 8.40061L8.48962 8.57272V7.4322H9.51044V8.57272H9.51041Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.21495 10.817H8.01556C8.14182 10.817 8.24419 10.7202 8.24419 10.6009C8.24419 10.4815 8.14182 10.3848 8.01556 10.3848H7.21495C7.08869 10.3848 6.98633 10.4815 6.98633 10.6009C6.98633 10.7202 7.08869 10.817 7.21495 10.817Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.21495 11.7349H8.01556C8.14182 11.7349 8.24419 11.6382 8.24419 11.5188C8.24419 11.3995 8.14182 11.3027 8.01556 11.3027H7.21495C7.08869 11.3027 6.98633 11.3995 6.98633 11.5188C6.98633 11.6382 7.08869 11.7349 7.21495 11.7349Z",
			fill: "#395566"
		})
	]
});
export default SvgSalesOrder;
